export const ROUTING = {
  main: '/',
  autopaySdk: {
    main: '/autopay-sdk',
    product: '/autopay-sdk/o-produkcie',
    docs: {
      main: '/autopay-sdk/dokumentacja',
      android: '/autopay-sdk/dokumentacja/android',
      ios: '/autopay-sdk/dokumentacja/ios'
    },
    files: {
      main: '/autopay-sdk/pliki-do-pobrania',
      android: '/autopay-sdk/pliki-do-pobrania/android',
      ios: '/autopay-sdk/pliki-do-pobrania/ios'
    },
    faq: {
      main: '/autopay-sdk/faq',
      android: '/autopay-sdk/faq/android',
      ios: '/autopay-sdk/faq/ios'
    },
    changelog: {
      main: '/autopay-sdk/changelog',
      android: '/autopay-sdk/changelog/android',
      ios: '/autopay-sdk/changelog/ios'
    }
  }
}
